'use client'

import { QueryClient } from '@tanstack/react-query'

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        if (typeof error === 'object' && error && 'status' in error && error.status === 401) {
          return false
        }

        return failureCount < 2
      },
    },
  },
})

export function clearAppQueryClient() {
  appQueryClient.clear()
}
